import React, { useEffect, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import DeleteModal from '../../components/DeleteModal';
import EducationEmploymentList from '../../components/EducationEmploymentList';
import EducationEmploymentAddForm from '../../components/EducationEmploymentAddForm';

import {
  deleteEmployment,
  fetchEmployment,
} from '../../actions/employmentActions';
import { DELETE_EMPLOYMENT_RESET } from '../../constants/employmentConstants';

function Employment() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const employmentState = useSelector((state) => state.employmentList) || {};
  const { employments } = employmentState;
  const { error: errorDelete, success: successDelete } = useSelector(
    (state) => state.employmentDelete
  );

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [employmentToDelete, setEmploymentToDelete] = useState(null);

  useEffect(() => {
    if (successDelete) {
      setShowDeleteModal(false);
      dispatch({ type: DELETE_EMPLOYMENT_RESET });
      dispatch(fetchEmployment());
    }
  }, [dispatch, successDelete]);

  useEffect(() => {
    dispatch(fetchEmployment());
  }, [dispatch]);

  const handleShowDeleteModal = (id) => {
    setEmploymentToDelete(id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (employmentToDelete) {
      dispatch(deleteEmployment(employmentToDelete));
    }
  };

  const handleEdit = (emp, type) => {
    if (type === 'description') {
      navigate('/employment/description', {
        state: {
          id: emp.id,
          position: emp.position,
          employer_name: emp.employer_name,
          city: emp.city,
          start_date: emp.start_date?.slice(0, 7),
          end_date: emp.end_date?.slice(0, 7),
          currentlyWorking: !emp.end_date,
          description: emp.description || [],
        },
      });
    } else {
      navigate('/employment/form', {
        state: {
          id: emp.id,
          position: emp.position,
          employer_name: emp.employer_name,
          city: emp.city,
          start_date: emp.start_date?.slice(0, 7),
          end_date: emp.end_date?.slice(0, 7),
          currentlyWorking: !emp.end_date,
          description: emp.description || [],
        },
      });
    }
  };

  const capitalize = (str) =>
    !str ? '' : str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}.${year}`;
  };

  return (
    <Container>
      <Col xs={12} md={8} className="mx-auto">
      <Row className="mt-3">
        <Col>
          <h1 className="fw-bold">Doświadczenie zawodowe</h1>
        </Col>
      </Row>

      <Row>
        <Col>
          {employments && employments.length > 0 ? (
            employments.map((emp, index) => (
              <EducationEmploymentList
                key={emp.id}
                id={emp.id}
                number={index + 1}
                position={capitalize(emp.position)}
                name={capitalize(emp.employer_name)}
                city={capitalize(emp.city)}
                start_date={formatDate(emp.start_date)}
                end_date={emp.end_date ? formatDate(emp.end_date) : 'Obecnie'}
                tasks={emp.description || []}
                onDelete={() => handleShowDeleteModal(emp.id)}
                onEdit={(type) => handleEdit(emp, type)}
              />
            ))
          ) : (
            <div className="text-secondary fst-italic mt-3">
              Brak informacji o doświadczeniu zawodowym
            </div>
          )}
        </Col>
      </Row>
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        error={errorDelete}
      />
      <Row>
        <Col>
          <EducationEmploymentAddForm name="Dodaj stanowisko" nextlink ='/employment/form' />
        </Col>
      </Row>
      </Col>
    </Container>
  );
}

export default Employment;
